import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { EditorBookingItem } from '../editor-booking-item/editor-booking-item.model';
import { EditorBookingItemSetting } from './editor-booking-item-setting.model';
import { EditorBookingItemEditStore } from '../editor-booking-item-edit/editor-booking-item-edit.store';
import { EditorDialogStore } from '../editor-dialog/editor-dialog.store';


@Component({
    // tslint:disable-next-line:component-selector
    selector: '[eas-editor-booking-item-setting]',
    templateUrl: './editor-booking-item-setting.component.html',
    styleUrls: ['./editor-booking-item-setting.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EditorBookingItemSettingComponent implements OnInit {
  @Input() item: EditorBookingItem;
  @Input() itemSetting: EditorBookingItemSetting;
  @Input() itemSettingIndex: number;

  constructor(
    protected itemEditStore: EditorBookingItemEditStore,
    private itemDialogStore: EditorDialogStore
  ) {

  }

  ngOnInit() {

  }

  onEdit() {
    this.itemEditStore.startEditing(this.item.id, { name: 'settings', value: this.itemSettingIndex });
    this.itemDialogStore.editBookingItem();
    return false;
  }

  get cssClassName(): string {
    switch (this.itemSetting.inheritableType) {
      case 'empty':
        return '';
      case 'set':
      case 'inherited':
      case 'inherited-overridden':
      case 'overridden':
        return 'option_row--set';
    }
  }
}
